(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownBar {
    constructor(el) {
      this.el = el;
      this.nums = {
        days: el.querySelector('[data-days]'),
        hours: el.querySelector('[data-hours]'),
        minutes: el.querySelector('[data-minutes]'),
        seconds: el.querySelector('[data-seconds]'),
      };
      const raw = (el.dataset.deadline || '').trim();
      this.deadline = raw ? new Date(raw.replace(' ', 'T')).getTime() : NaN;
      if (isNaN(this.deadline)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
    tick() {
      const diff = this.deadline - Date.now();
      if (diff <= 0) {
        Object.values(this.nums).forEach((n) => n && (n.textContent = '00'));
        clearInterval(this.timer);
        return;
      }
      const s = Math.floor(diff / 1000);
      this.nums.days.textContent = this.pad(Math.floor(s / 86400));
      this.nums.hours.textContent = this.pad(Math.floor((s % 86400) / 3600));
      this.nums.minutes.textContent = this.pad(Math.floor((s % 3600) / 60));
      this.nums.seconds.textContent = this.pad(s % 60);
    }
  }
  document.querySelectorAll('.countdown-bar [data-countdown]').forEach((el) => new CountdownBar(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.promo-hero').forEach(function (hero) {
      var viewport = hero.querySelector('.promo-hero__viewport');
      var prev = hero.querySelector('[data-ph-prev]');
      var next = hero.querySelector('[data-ph-next]');
      // Le défilement (swipe + boucle infinie) ne dépend PAS des flèches :
      // on continue même si elles sont masquées.
      if (!viewport) return;

      function cardWidth() {
        var card = hero.querySelector('.promo-hero__card');
        return card ? card.getBoundingClientRect().width : viewport.clientWidth;
      }
      // Largeur d'UN groupe (le track est doublé pour la boucle infinie)
      function groupWidth() {
        var g = hero.querySelector('.promo-hero__group');
        return g ? g.getBoundingClientRect().width : viewport.scrollWidth / 2;
      }

      // Recale instantanément si on dépasse une borne → effet infini sans blanc
      function normalize() {
        var gw = groupWidth();
        if (gw <= 0) return;
        if (viewport.scrollLeft >= gw) {
          viewport.scrollLeft -= gw;
        } else if (viewport.scrollLeft < 0) {
          viewport.scrollLeft += gw;
        }
      }

      function go(dir) {
        hero.classList.add('promo-hero--manual');
        // Si on va à gauche et qu'on est au tout début, saute d'abord à la copie
        if (dir < 0 && viewport.scrollLeft < cardWidth()) {
          viewport.scrollLeft += groupWidth();
        }
        viewport.scrollBy({ left: dir * cardWidth(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      // Dès que l'utilisateur touche/swipe : on fige l'animation auto et on passe
      // au scroll natif (sinon l'animation transform se bat avec le doigt).
      // On synchronise le scrollLeft sur la position visuelle courante de l'animation.
      function adoptScrollFromAnimation() {
        if (hero.classList.contains('promo-hero--manual')) return;
        var track = hero.querySelector('.promo-hero__track');
        if (track) {
          var m = new DOMMatrixReadOnly(getComputedStyle(track).transform);
          var shifted = -m.m41; // translateX courant (négatif) → scrollLeft positif
          hero.classList.add('promo-hero--manual');
          if (shifted > 0) viewport.scrollLeft = shifted;
        } else {
          hero.classList.add('promo-hero--manual');
        }
      }
      viewport.addEventListener('touchstart', adoptScrollFromAnimation, { passive: true });
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.pointerType === 'pen') adoptScrollFromAnimation();
      }, { passive: true });

      // Après chaque scroll (flèche OU swipe), on recale pour la boucle
      var t = null;
      viewport.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(normalize, 140);
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
